import React from 'react';
import theme from './Cards.module.scss';
import { ExpandableCardHandleProps } from '.';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';

const ExpandableCardHandle: React.FC<ExpandableCardHandleProps> = ({
    expanded,
    expandText = <Trans>Show details</Trans>,
    collapseText = <Trans>Hide details</Trans>,
    onExpandToggle,
    width = '130px',
    disabled = false,
}) => {
    return (
        <div className={theme.expandHandleWrapper} style={{ width: width || 'auto', flexShrink: width ? 0 : undefined }}>
            <button
                className={theme.expandHandle}
                onClick={(e) => onExpandToggle(!expanded)}
                disabled={disabled}
                type="button">
                {expanded ? collapseText : expandText}
                <FontAwesomeIcon icon={faAngleDown} rotation={expanded ? 180 : undefined} size="2x" />
            </button>
        </div>
    );
};

export default ExpandableCardHandle;